<template>

<section class="container my-2">

<div class="board shadow">

  <h3>Cards</h3>
  <p class="display-8">A card is a flexible end extensible container. It includes options for headers and footers, a wide variety of content, contextual background colors, and powerful display options.</p>
  <p>By default, it takes the full width of it's parent element, so a single card will need additional styling to set it's intended width.</p>
  <br><hr>

  <p class='bold'>● Card - Plain (no header and footer)</p>

  <div class="box-border">
    <sym-card>Default style of a card takes up the entire width of container with a border in lightgray.
      A default bottom margin is also included. Cards are ideal as generic containers to hold any content.
    </sym-card>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="5">
  <sym-card>Default style of a card takes up the entire width of container with a border in lightgray.
    A default bottom margin is also included. Cards are ideal as generic containers to hold any content.
  </sym-card>
  </textarea>

  <br><hr>

  <p class='bold'>● Card - Basic</p>

  <div class="box-border">
    <!-- <sym-card class="fw-88"> -->
    <sym-card class="fw-68">
      <img slot="img-top" src="../../img/sample/suzuki.jpg" class="img-fluid">

      <h5 slot="title">Suzuki</h5>
      <h6 slot="subtitle">Model GSX-R1200</h6>
      <p>Some quick example text to build on the card title/subtitle and make up the bulk of the card's content.</p>

      <sym-link class="button success" to="#review" >Show Review</sym-link>
    </sym-card>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="11">
  <sym-card class="fw-68">
    <img slot="img-top" src="../../img/sample/suzuki.jpg">

    <h5 slot="title">Suzuki</h5>
    <h6 slot="subtitle">Model GSX-R1200</h6>
    <p>Some quick example text to build on the card title/subtitle and make up the bulk of the card's content.</p>

    <sym-link class="button success" to="#review" >Show Review</sym-link>
  </sym-card>
  </textarea>

  <br><hr>


  <p class='bold'>● Card - styling and options</p>

  <div class="box-border">
    <!-- <sym-card class="warning-light border-warning shadow w-fit"> -->
    <sym-card class="warning-light border-warning shadow">
      <div slot="header" class="text-center">
        <b>Flexibility</b>
      </div>

      Color schemes available system-wide (as CSS classes):
      <ul class="ml-4">
        <li>info / info-light</li>
        <li>success / success-light</li>
        <li>warning / warning-light</li>
        <li>danger / danger-light</li>
        <li>primary / primary-light</li>
        <li>secondary / secondary-light</li>
        <li>dark / dark-light</li>
        <li>light</li>
      </ul>
      <hr>
      <span>This card is using color scheme 'warning-light' with header text centered (default is left-aligned),
        border color set to 'border-warning' class, and shadow effect applled via class 'shadow'. An optional image
        may be shown on the top or bottom (see the other examples in this section).
      </span>
    </sym-card>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="24">
  <sym-card class="warning-light border-warning shadow">
    <div slot="header" class="text-center">
      <b>Flexibility</b>
    </div>

    Color schemes available system-wide (as CSS classes):
    <ul class="ml-4">
      <li>info / info-light</li>
      <li>success / success-light</li>
      <li>warning / warning-light</li>
      <li>danger / danger-light</li>
      <li>primary / primary-light</li>
      <li>secondary / secondary-light</li>
      <li>dark / dark-light</li>
      <li>light</li>
    </ul>
    <hr>
    <span>This card is using color scheme 'warning-light' with header text centered (default is left-aligned),
      border color set to 'border-warning' class, and shadow effect applled via class 'shadow'. An optional image
      may be shown on the top or bottom (see the other examples in this section).
    </span>
  </sym-card>
  </textarea>

  <br><hr>

  <p class='bold'>● Card - using only the header section as toolbar backdrop. Note the use of SymCSS spacing utilities px-*, pt-*, pb-*, mr-* to achieve the intended effect.</p>

  <div class="box-border">
    <sym-card class="border-main w-fit" headerClass="light px-1 pt-1 pb-0">
      <div slot="header" class="buttons" info>
        <button><i class="fa fa-lg fa-close mr-2"></i>Cancel</button>
        <button><i class="fa fa-lg fa-undo mr-2"></i>Reinstate</button>
        <button><i class="fa fa-lg fa-print mr-2"></i>Print Folio</button>
        <button><i class="fa fa-lg fa-check mr-2"></i>Check-In</button>
      </div>
    </sym-card>

    <sym-card class="border-main w-fit" headerClass="light px-1 pt-1 pb-0">
      <div slot="header" class="buttons" info-light outline>
        <button><i class="fa fa-lg fa-close mr-2"></i>Cancel</button>
        <button><i class="fa fa-lg fa-undo mr-2"></i>Reinstate</button>
        <button><i class="fa fa-lg fa-print mr-2"></i>Print Folio</button>
        <button><i class="fa fa-lg fa-check mr-2"></i>Check-In</button>
      </div>
    </sym-card>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="19">
  <sym-card class="border-main w-fit" headerClass="light px-1 pt-1 pb-0">
    <div slot="header" class="buttons" info>
      <button><i class="fa fa-lg fa-close mr-2"></i>Cancel</button>
      <button><i class="fa fa-lg fa-undo mr-2"></i>Reinstate</button>
      <button><i class="fa fa-lg fa-print mr-2"></i>Print Folio</button>
      <button><i class="fa fa-lg fa-check mr-2"></i>Check-In</button>
    </div>
  </sym-card>

  <sym-card class="border-main w-fit" headerClass="light px-1 pt-1 pb-0">
    <div slot="header" class="buttons" info-light outline>
      <button><i class="fa fa-lg fa-close mr-2"></i>Cancel</button>
      <button><i class="fa fa-lg fa-undo mr-2"></i>Reinstate</button>
      <button><i class="fa fa-lg fa-print mr-2"></i>Print Folio</button>
      <button><i class="fa fa-lg fa-check mr-2"></i>Check-In</button>
    </div>
  </sym-card>
  </textarea>

  <br><hr>

  <p class='bold'>● Card - fixed-width (class 'fw-68'); using header, footer, and color scheme 'warning-light'; all content centered via class 'text-center' set at container level</p>

  <div class="box-border">
    <sym-card class='warning-light fw-68 text-center'>
      <div slot="header">
        <b>Tropical Paradise</b>
      </div>

      <h5 slot="title">Coron Island</h5>
      <h6 slot="subtitle">Palawan, Philippines</h6>
      <p>
        This is the body of the card; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
        est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
      </p>
      <sym-link class="button success shadow" to="#book" >Book Now</sym-link>

      <img slot="img-top" src="../../img/sample/coron.jpg">

      <div slot="footer">
        Footer - Tropical Paradise
      </div>
    </sym-card>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="21">
  <sym-card class='warning-light fw-68 text-center'>
    <div slot="header">
      <b>Tropical Paradise</b>
    </div>

    <h5 slot="title">Coron Island</h5>
    <h6 slot="subtitle">Palawan, Philippines</h6>
    <p>
      This is the body of the card; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
      est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
    </p>
    <sym-link class="button success shadow" to="#book" >Book Now</sym-link>

    <img slot="img-top" src="../../img/sample/coron.jpg">

    <div slot="footer">
      Footer - Tropical Paradise
    </div>
  </sym-card>
  </textarea>

  <br><hr>

  <p class='bold'>● Cards in CSS Grid container - responsive layout using media queries</p>

  <div class="box-border">

    <div class="cards-summer">
      <sym-card class='card-item info-light shadow'>
        <div slot="header">
          <b>Umbrellas</b>
        </div>

        <p class="lg-1 mb-0">This is the body of the card; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
          est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>

        <img slot="img-bottom" src="../../img/sample/parasol.jpg">

        <div slot="footer">
          Footer - Parasol/Paraguas
        </div>
      </sym-card>

      <sym-card class='card-item warning-light shadow text-center'>
        <div slot="header">
          <b>Tropical Beach</b>
        </div>

        <h5 slot="title">Boracay Island</h5>
        <h6 slot="subtitle">Aklan, Philippines</h6>

        <p>This is the body of the card; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
          est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>
        <sym-link class="button success" to="#book" >Book Now</sym-link>

        <img slot="img-top" src="../../img/sample/beach.jpg">

        <div slot="footer">
          Footer - Tropical Beach
        </div>
      </sym-card>

      <sym-card class='card-item dark shadow'>
        <div slot="header">
          <b>Seasons</b>
        </div>

        <div class="media mb-3">
          <img class="mr-3 border-dark circle" src="../../img/sample/dimples.jpg" width="40%">
          <div class="media-body">
            <h5>Dimples Romana</h5>
            <span>Actress and commercial model</span>
          </div>
        </div>

        <hr>

        <p class="lg-1 mb-0">This is the body of the card; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
          est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
        </p>

        <img slot="img-bottom" src="../../img/sample/seasons.jpg">

        <div slot="footer">
          Footer - Seasons
        </div>
      </sym-card>
    </div>
  </div>

  <textarea class="code" disabled wrap="off" spellcheck="false" rows="65">
  <div class="cards-summer">
    <sym-card class='card-item info-light shadow'>
      <div slot="header">
        <b>Umbrellas</b>
      </div>

      <p class="lg-1 mb-0">This is the body of the card; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
        est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
      </p>

      <img slot="img-bottom" src="../../img/sample/parasol.jpg">

      <div slot="footer">
        Footer - Parasol/Paraguas
      </div>
    </sym-card>

    <sym-card class='card-item warning-light shadow text-center'>
      <div slot="header">
        <b>Tropical Beach</b>
      </div>

      <h5 slot="title">Boracay Island</h5>
      <h6 slot="subtitle">Aklan, Philippines</h6>

      <p>This is the body of the card; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
        est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
      </p>
      <sym-link class="button success" to="#book" >Book Now</sym-link>

      <img slot="img-top" src="../../img/sample/beach.jpg">

      <div slot="footer">
        Footer - Tropical Beach
      </div>
    </sym-card>

    <sym-card class='card-item dark shadow'>
      <div slot="header">
        <b>Seasons</b>
      </div>

      <div class="media mb-3">
        <img class="mr-3 border-dark circle" src="../../img/sample/dimples.jpg" width="40%">
        <div class="media-body">
          <h5>Dimples Romana</h5>
          Actress and commercial model
        </div>
      </div>

      <hr>

      <p class="lg-1 mb-0">This is the body of the card; Lorem ipsum dolor sit amet, habitasse magna facilisi nulla,
        est tincidunt, vel et maecenas, eros quam non. Cum accumsan eros aliquam aenean et.
      </p>

      <img slot="img-bottom" src="../../img/sample/seasons.jpg">

      <div slot="footer">
        Footer - Seasons
      </div>
    </sym-card>
  </div>
  </textarea>

</div>

</section>

</template>

<script>

import PageBase from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'samples-card'

}

</script>

<style scoped>

.cards-summer {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  /* row-gap: 1rem;
  column-gap: 1rem; */
}

.card-item {
  height: 100%;
}

@media (max-width: 576px) {
  .cards-summer {
    grid-template-columns: 1fr !important;
  }
}

@media (max-width: 800px) {
  .cards-summer {
    grid-template-columns: repeat(2, 1fr);
  }
}

</style>
